module.exports = __webpack_public_path__ + "static/training_0-cb50d008dc6d890cf50f3ced38f5f622.svg";